import type React from "react"
import { FileText, CheckCircle, PieChart, Award } from "lucide-react"

interface StatCardProps {
  icon: React.ReactNode
  title: string
  value: string | number
  description: string
  iconBgColor: string
  iconColor: string
  showProgress?: boolean
  progressValue?: number
  progressColor?: string
}

function StatCard({
  icon,
  title,
  value,
  description,
  iconBgColor,
  iconColor,
  showProgress,
  progressValue,
  progressColor,
}: StatCardProps) {
  return (
    <div className="flex flex-col gap-2 rounded-xl p-6 bg-white border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-center gap-3">
        <div className={`${iconBgColor} p-2 rounded-lg ${iconColor}`}>{icon}</div>
        <p className="text-gray-500 text-sm font-bold uppercase tracking-wide">{title}</p>
      </div>
      <p className="text-gray-900 text-3xl font-black mt-2">{value}</p>
      {showProgress && progressValue !== undefined ? (
        <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2">
          <div className={`${progressColor} h-1.5 rounded-full`} style={{ width: `${progressValue}%` }} />
        </div>
      ) : (
        <p className="text-xs text-gray-500 mt-1">{description}</p>
      )}
    </div>
  )
}

export function AssessmentStats() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 py-4">
      <StatCard
        icon={<FileText className="h-5 w-5" />}
        title="Total"
        value="124"
        description="Total assessments created"
        iconBgColor="bg-[#13ecda]/20"
        iconColor="text-gray-900"
      />
      <StatCard
        icon={<CheckCircle className="h-5 w-5" />}
        title="Active"
        value="12"
        description="Currently open for students"
        iconBgColor="bg-green-100"
        iconColor="text-green-700"
      />
      <StatCard
        icon={<PieChart className="h-5 w-5" />}
        title="Avg. Completion"
        value="78%"
        description=""
        iconBgColor="bg-blue-100"
        iconColor="text-blue-700"
        showProgress
        progressValue={78}
        progressColor="bg-blue-500"
      />
      <StatCard
        icon={<Award className="h-5 w-5" />}
        title="Avg. Score"
        value="82%"
        description="Average Overall Students Performance "
        iconBgColor="bg-purple-100"
        iconColor="text-purple-700"
        showProgress
        // progressValue={82}
        progressColor="bg-purple-500"
      />
    </div>
  )
}
